import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { searchAdminTimeCards, searchTimeCards } from '@lib/api'
import { timeCardKeys } from '@lib/keys'
import { DateTime } from 'luxon'

export const useTimeCards = ({ userId = 0, start, end }: { userId: number; start: DateTime; end: DateTime }) => {
  return useQuery(
    timeCardKeys.search(userId, start, end),
    () => searchTimeCards(userId, start, end),
    { enabled: userId !== 0 },
  )
}

export const useAdminTimeCards = (startDate: DateTime, endDate: DateTime) => {
  return useQuery(timeCardKeys.adminSearch(startDate, endDate), () =>
    searchAdminTimeCards(startDate, endDate),
  )
}

export const useTimeCardById = ({
  id = 0,
  userId = 0,
  start,
  end,
}: {
  id?: number
  userId?: number
  start: DateTime
  end: DateTime
}) => {
  const timeCardsQuery = useTimeCards({ userId, start, end })

  return useMemo(() => {
    if (timeCardsQuery.data === undefined) return

    return timeCardsQuery.data.find((card) => card.id === id)
  }, [timeCardsQuery.data, id])
}
